import { useState, forwardRef, useImperativeHandle, ChangeEvent } from "react";
import { Status as StatusType } from "../../../features/notifications/notificationSlice";
import useGetLanguage from "../../../utils/useGetLanguage";
import { LanguageText } from "../../../dictionary/GroupNotificationText";
import ToggleSwitch from "../../../utils/ToggleSwitch";

export interface NotificationStatusProps {
  status: StatusType;
  onStatusChange: React.Dispatch<React.SetStateAction<StatusType>>;
}
const NotificationStatus = ({
  status,
  onStatusChange,
}: NotificationStatusProps): JSX.Element => {
  //   const [error, setError] = useState("");
  const Language: LanguageText = useGetLanguage({
    fileName: "GroupNotificationText",
  });

  //   const handleActiveCheckChange = (event: ChangeEvent<HTMLInputElement>) => {
  //     const { name, checked } = event.target;
  //     setNotificationStatus((prev) => ({
  //       ...prev,
  //       active: checked,
  //     }));
  //   };

  const handleActiveSwitchChange = (isActive: boolean) => {
    onStatusChange((prev) => ({
      ...prev,
      active: !isActive,
    }));
  };

  return (
    <div className="mb-6 bg-gray-100 p-5 rounded-lg mt-2">
      {/* Stack */}
      {/* <>
          <h1 className="text-sm font-semibold text-left text-gray-800 leading-tight mb-2">
            {language?.statusComponent?.heading || "Status"}
          </h1>
          <div className="w-full flex items-center p-0">
            <input
              type="checkbox"
              name="active"
              checked={notificationStatus.active}
              onChange={handleActiveCheckChange}
              className="form-checkbox h-5 w-5 text-blue-600 focus:ring-blue-500 rounded mr-2"
            />
            <label className="text-gray-700">
              {language?.statusComponent?.active || "Active"}
            </label>
          </div>
          
        </> */}

      {/* Inline */}
      <>
        <h1 className="text-sm font-semibold text-left text-gray-800 leading-tight mb-2">
          {Language?.status}
        </h1>
        <div className="w-full flex items-center p-0">
          {/* <div className="flex items-center mr-4">
              <input
                type="checkbox"
                name="active"
                checked={notificationStatus.active}
                onChange={handleActiveCheckChange}
                className="form-checkbox h-5 w-5 text-blue-600 focus:ring-blue-500 rounded mr-2"
              />
              <label className="text-gray-700">
                {language?.statusComponent?.active || "Active"}
              </label>
            </div> */}
          <div className="flex items-center">
            <ToggleSwitch
              isActive={status?.active}
              onToggle={() => handleActiveSwitchChange(status?.active)}
            />
            <label className="text-gray-700 ml-2 mr-2">{Language?.active}</label>
          </div>
          {/* <div className="flex items-center">
              <input
                type="checkbox"
                name="current"
                checked={false}
                className="form-checkbox h-5 w-5 text-blue-600 focus:ring-blue-500 rounded mr-2"
              />
              <label className="text-gray-700">Current</label>
            </div> */}
        </div>
      </>
    </div>
  );
};

export default NotificationStatus;
